import { render, staticRenderFns } from "./Permissoes.vue?vue&type=template&id=933c9104&"
import script from "./Permissoes.vue?vue&type=script&lang=js&"
export * from "./Permissoes.vue?vue&type=script&lang=js&"
import style0 from "./Permissoes.vue?vue&type=style&index=0&id=933c9104&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports